import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import cart  from "./cart/cart";
import porterbuilder from "./porterbuilder/porterbuilder";
import productList from "./productList/productList";
import { CartState, PorterBuilderState, ProductListState, PorterItemsState, PorterBudgetState } from './types';
import { getStoreBuilder } from 'vuex-typex';

export interface RootState{
    cart: CartState,
    porterBuilder: PorterBuilderState,
    productList: ProductListState,
    porterItemsState: PorterItemsState;
    porterBudgetState: PorterBudgetState;
}

Vue.use(Vuex)
const store: Store<RootState> = getStoreBuilder<RootState>().vuexStore();
export default store;